import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'app/core/route.service';
import { ExecuteProcessComponent } from 'app/executeProcess/executeProcess.component';


const routes: Routes = Route.withShell([
  { path: 'process/execute/:id', component:  ExecuteProcessComponent, data: { titleKey: 'PROCESS.EXECUTE.PAGE_TITLE' } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ExecuteProcessRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/executeProcess/executeProcess-routing.module.ts